var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcResetDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 44,
    fill: "#08BD80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.2703 30.0903L37.995 54.1381L26.9264 41.531L24.2376 43.8092L37.8286 59.2896L64.8067 32.5636L62.2703 30.0903Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResetDone);
export default __webpack_public_path__ + "static/media/ic_reset_done.ae02ff557ba43fd75772a84a3a23bdbc.svg";
export { ForwardRef as ReactComponent };